var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#131415",
    fillRule: "evenodd",
    d: "M34.512 8.821c.65.651.65 1.707 0 2.357L16.178 29.512c-.65.65-1.706.65-2.357 0l-8.333-8.334a1.667 1.667 0 1 1 2.357-2.357L15 25.977 32.155 8.821c.65-.65 1.706-.65 2.357 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgChecked;